module.exports = __webpack_public_path__ + "logo-full-white.png";